import { FC, useEffect } from "react";
import { Form, Select, DatePicker, FormInstance } from "antd";
import dayjs from "dayjs";
import { RangePickerProps } from "antd/es/date-picker";
const { Option } = Select;

interface DueDateOrderDialogProps {
  form: FormInstance;
  dueDate: any;
}

const DueDateOrderDialog: FC<DueDateOrderDialogProps> = ({
  dueDate,
  form
}) => {

  useEffect(()=> {
    const dueDateObject = dayjs(dueDate);
    form.setFieldsValue({
      due_date: dueDateObject
    })
  }, [dueDate])

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current < dayjs().startOf('day');
  };
  
  return (
    <>
      <Form.Item
        label={`วันที่ต้องส่งสินค้า`}
        labelAlign="left"
        name="due_date"
        rules={[
          {
            required: true,
            message: "กรุณาระบุวันที่ต้องส่งสินค้า",
          },
        ]}
      >
        <DatePicker          
          disabledDate={disabledDate}         
          format="YYYY-MM-DD"
          placeholder="วันที่ต้องส่งสินค้า"
        />
      </Form.Item>
    </>
  );
}
export default DueDateOrderDialog;
